import { render, staticRenderFns } from "./HomeEn.vue?vue&type=template&id=f447e6a2&scoped=true"
import script from "./HomeEn.vue?vue&type=script&lang=js"
export * from "./HomeEn.vue?vue&type=script&lang=js"
import style0 from "./HomeEn.vue?vue&type=style&index=0&id=f447e6a2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f447e6a2",
  null
  
)

export default component.exports